var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgBasket = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-3 -3 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(0.5 40) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5,8a1,1,0,1,0,0,2h2.18l1.839,9.2a1,1,0,0,0,.981.8H25.156l-.9,3H13.5a1,1,0,0,0,0,2H25a1,1,0,0,0,.958-.713l1.5-5V19.27l2-7A1,1,0,0,0,28.5,11H12.92l-.439-2.2A1,1,0,0,0,11.5,8Zm5.82,10-1-5H27.174l-1.429,5Z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5,29a3,3,0,1,1-.879-2.121A3,3,0,0,1,18.5,29Zm-2,0a1,1,0,1,1-.293-.707A1,1,0,0,1,16.5,29Z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.167,31.494a3,3,0,1,1,1.1-1.346A3,3,0,0,1,26.167,31.494Zm-1.111-1.663a1,1,0,1,1,.368-.449A1,1,0,0,1,25.056,29.831Z",
    transform: "translate(2)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBasket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/basket.68997ff0.svg";
export { ForwardRef as ReactComponent };